import { List } from '../objects/list';
import { Error } from '../objects/error';
import { Picture } from '../../picture/objects/picture';
import { Preferences } from '../../profile/objects/preferences';
import { ProviderActivation } from '../objects/providerActivation';
import { Errors as PictureErrors } from '../../picture/objects/errors';
import { CustomProvider } from '../../customProvider/objects/customProvider';
import { OrganisationMinimal } from '../../organisation/objects/organisationMinimal';
import { Column } from '../objects/column';

export const ADD_ACTIVATION_EXTRA_PARAM = 'PROVIDER_ADD_ACTIVATION_EXTRA_PARAM';
export const ADD_PREFERENCES = 'PROVIDER_ADD_PREFERENCES';
export const DELETE_ACTIVATION_EXTRA_PARAM = 'PROVIDER_DELETE_ACTIVATION_EXTRA_PARAM';
export const MOVE_DOWN_COLUMN = 'PROVIDER_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'PROVIDER_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'PROVIDER_RESET_FILTERS';
export const RESET_PROVIDER = 'PROVIDER_RESET_PROVIDER';
export const SET_ACTIVATION_LIST = 'PROVIDER_SET_ACTIVATION_LIST';
export const SET_EDIT_STEP = 'PROVIDER_SET_EDIT_STEP';
export const SET_ERRORS = 'PROVIDER_SET_ERRORS';
export const SET_EXPORT_TYPE = 'PROVIDER_SET_EXPORT_TYPE';
export const SET_LIMIT = 'PROVIDER_SET_LIMIT';
export const SET_LIST = 'PROVIDER_SET_LIST';
export const SET_ORDER_BY = 'PROVIDER_SET_ORDER_BY';
export const SET_PAGE = 'PROVIDER_SET_PAGE';
export const SET_PICTURE_ERRORS = 'PROVIDER_SET_PICTURE_ERRORS';
export const SET_POST_FINISHED = 'PROVIDER_SET_POST_FINISHED';
export const SET_PROVIDER_ACTIVATION = 'PROVIDER_SET_PROVIDER_ACTIVATION';
export const SET_PREFERENCES = 'PROVIDER_SET_PREFERENCES';
export const SET_PROVIDER = 'PROVIDER_SET_PROVIDER';
export const SET_RUNNING = 'PROVIDER_SET_RUNNING';
export const SET_SEARCH = 'PROVIDER_SET_SEARCH';
export const TOGGLE_AUTO_BOOKING = 'PROVIDER_TOGGLE_AUTO_BOOKING';
export const TOGGLE_COLUMN = 'PROVIDER_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'PROVIDER_TOGGLE_CREATE';
export const TOGGLE_EDIT = 'PROVIDER_TOGGLE_EDIT';
export const TOGGLE_EXPORT = 'PROVIDER_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'PROVIDER_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'PROVIDER_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'PROVIDER_TOGGLE_REFRESH';
export const UPDATE_ACTIVATION_CONTENT_TYPES = 'PROVIDER_UPDATE_ACTIVATION_CONTENT_TYPES';
export const UPDATE_ACTIVATION_EMAIL = 'PROVIDER_UPDATE_ACTIVATION_EMAIL';
export const UPDATE_ACTIVATION_ENDPOINT = 'PROVIDER_UPDATE_ACTIVATION_ENDPOINT';
export const UPDATE_ACTIVATION_EXTRA_PARAM_KEY = 'PROVIDER_UPDATE_ACTIVATION_EXTRA_PARAM_KEY';
export const UPDATE_ACTIVATION_EXTRA_PARAM_VALUE = 'PROVIDER_UPDATE_ACTIVATION_EXTRA_PARAM_VALUE';
export const UPDATE_ACTIVATION_IDENTIFIER = 'PROVIDER_UPDATE_ACTIVATION_IDENTIFIER';
export const UPDATE_ACTIVATION_KEY = 'PROVIDER_UPDATE_ACTIVATION_KEY';
export const UPDATE_ACTIVATION_ORGANISATION = 'PROVIDER_UPDATE_ACTIVATION_ORGANISATION';
export const UPDATE_ADDRESS = 'PROVIDER_UPDATE_ADDRESS';
export const UPDATE_BOOKING_EMAIL = 'PROVIDER_UPDATE_BOOKING_EMAIL';
export const UPDATE_CITY = 'PROVIDER_UPDATE_CITY';
export const UPDATE_CODE = 'PROVIDER_UPDATE_CODE';
export const UPDATE_COMPLEMENTARY_ADDRESS = 'PROVIDER_UPDATE_COMPLEMENTARY_ADDRESS';
export const UPDATE_CONTACT_EMAIL = 'PROVIDER_UPDATE_CONTACT_EMAIL';
export const UPDATE_CONTENT_TYPE = 'PROVIDER_UPDATE_CONTENT_TYPE';
export const UPDATE_COUNTRY = 'PROVIDER_UPDATE_COUNTRY';
export const UPDATE_FILTER_CONTENT_TYPE = 'PROVIDER_UPDATE_FILTER_CONTENT_TYPE';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'PROVIDER_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'PROVIDER_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'PROVIDER_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'PROVIDER_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'PROVIDER_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'PROVIDER_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_NAME = 'PROVIDER_UPDATE_FILTER_NAME';
export const UPDATE_FILTER_PERIOD = 'PROVIDER_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'PROVIDER_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_LANGUAGE = 'PROVIDER_UPDATE_LANGUAGE';
export const UPDATE_NAME = 'PROVIDER_UPDATE_NAME';
export const UPDATE_PAYMENT_TYPE = 'PROVIDER_UPDATE_PAYMENT_TYPE';
export const UPDATE_PHONE_NUMBER = 'PROVIDER_UPDATE_PHONE_NUMBER';
export const UPDATE_PICTURE = 'PROVIDER_UPDATE_PICTURE';
export const UPDATE_PICTURE_PROGRESS = 'PROVIDER_UPDATE_PICTURE_PROGRESS';
export const UPDATE_SECONDARY_PHONE_NUMBER = 'PROVIDER_UPDATE_SECONDARY_PHONE_NUMBER';
export const UPDATE_ZIP_CODE = 'PROVIDER_UPDATE_ZIP_CODE';
export const SET_COLUMNS = 'PROVIDER_SET_COLUMNS';
export const RESIZE_COLUMN = 'PROVIDER_RESIZE_COLUMN';

interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}
interface AddActivationExtraParamAction {
    type: typeof ADD_ACTIVATION_EXTRA_PARAM
}

interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface DeleteActivationExtraParamAction {
    type: typeof DELETE_ACTIVATION_EXTRA_PARAM,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface ResetProviderAction {
    type: typeof RESET_PROVIDER
}

interface SetActivationListAction {
    type: typeof SET_ACTIVATION_LIST,
    payload: ProviderActivation[]
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: 'INFO' | 'ACTIVATION'
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPictureErrorsAction {
    type: typeof SET_PICTURE_ERRORS,
    payload: PictureErrors | null
}

interface SetPostFinishedAction {
    type: typeof SET_POST_FINISHED
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetProviderAction {
    type: typeof SET_PROVIDER,
    payload: CustomProvider
}

interface SetProviderActivationAction {
    type: typeof SET_PROVIDER_ACTIVATION,
    payload: boolean | null | ProviderActivation
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleAutoBookingAction {
    type: typeof TOGGLE_AUTO_BOOKING
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleEditAction {
    type: typeof TOGGLE_EDIT
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateActivationContentTypesAction {
    type: typeof UPDATE_ACTIVATION_CONTENT_TYPES,
    payload: number[]
}

interface UpdateActivationEmailAction {
    type: typeof UPDATE_ACTIVATION_EMAIL,
    payload: string
}

interface UpdateActivationEndpointAction {
    type: typeof UPDATE_ACTIVATION_ENDPOINT,
    payload: string
}

interface UpdateActivationExtraParamKeyAction {
    type: typeof UPDATE_ACTIVATION_EXTRA_PARAM_KEY,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateActivationExtraParamValueAction {
    type: typeof UPDATE_ACTIVATION_EXTRA_PARAM_VALUE,
    payload: {
        value: string,
        index: number
    }
}

interface UpdateActivationIdentifierAction {
    type: typeof UPDATE_ACTIVATION_IDENTIFIER,
    payload: string
}

interface UpdateActivationKeyAction {
    type: typeof UPDATE_ACTIVATION_KEY,
    payload: string
}

interface UpdateActivationOrganisationAction {
    type: typeof UPDATE_ACTIVATION_ORGANISATION,
    payload: null | OrganisationMinimal
}

interface UpdateAddressAction {
    type: typeof UPDATE_ADDRESS,
    payload: string
}

interface UpdateBookingEmailAction {
    type: typeof UPDATE_BOOKING_EMAIL,
    payload: string
}

interface UpdateCityAction {
    type: typeof UPDATE_CITY,
    payload: string
}

interface UpdateCodeAction {
    type: typeof UPDATE_CODE,
    payload: string
}

interface UpdateComplementaryAddressAction {
    type: typeof UPDATE_COMPLEMENTARY_ADDRESS,
    payload: string
}

interface UpdateContactEmailAction {
    type: typeof UPDATE_CONTACT_EMAIL,
    payload: string
}

interface UpdateContentTypeAction {
    type: typeof UPDATE_CONTENT_TYPE,
    payload: number[]
}

interface UpdateCountryAction {
    type: typeof UPDATE_COUNTRY,
    payload: string
}

interface UpdateFilterContentTypeAction {
    type: typeof UPDATE_FILTER_CONTENT_TYPE,
    payload: number[]
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterNameAction {
    type: typeof UPDATE_FILTER_NAME,
    payload: string
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateLanguageAction {
    type: typeof UPDATE_LANGUAGE,
    payload: string
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

interface UpdatePaymentTypeAction {
    type: typeof UPDATE_PAYMENT_TYPE,
    payload: string[]
}

interface UpdatePhoneNumberAction {
    type: typeof UPDATE_PHONE_NUMBER,
    payload: string
}

interface UpdatePictureAction {
    type: typeof UPDATE_PICTURE,
    payload: null | Picture,
}

interface UpdatePictureProgressAction {
    type: typeof UPDATE_PICTURE_PROGRESS,
    payload: number
}

interface UpdateSecondaryPhoneNumberAction {
    type: typeof UPDATE_SECONDARY_PHONE_NUMBER,
    payload: string
}

interface UpdateZipCodeAction {
    type: typeof UPDATE_ZIP_CODE,
    payload: string
}

export type ProviderActionTypes =
    SetColumnsAction |
    ResizeColumnAction |
    AddActivationExtraParamAction |
    AddPreferencesAction |
    DeleteActivationExtraParamAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    ResetProviderAction |
    SetActivationListAction |
    SetEditStepAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPictureErrorsAction |
    SetPostFinishedAction |
    SetPreferencesAction |
    SetProviderAction |
    SetProviderActivationAction |
    SetRunningAction |
    SetSearchAction |
    ToggleAutoBookingAction |
    ToggleColumnAction |
    ToggleNewAction |
    ToggleEditAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleRefreshAction |
    UpdateActivationContentTypesAction |
    UpdateActivationEmailAction |
    UpdateActivationEndpointAction |
    UpdateActivationExtraParamKeyAction |
    UpdateActivationExtraParamValueAction |
    UpdateActivationIdentifierAction |
    UpdateActivationOrganisationAction |
    UpdateActivationKeyAction |
    UpdateAddressAction |
    UpdateBookingEmailAction |
    UpdateCityAction |
    UpdateCodeAction |
    UpdateComplementaryAddressAction |
    UpdateContactEmailAction |
    UpdateContentTypeAction |
    UpdateCountryAction |
    UpdateFilterContentTypeAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterNameAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateLanguageAction |
    UpdateNameAction |
    UpdatePaymentTypeAction |
    UpdatePhoneNumberAction |
    UpdatePictureAction |
    UpdatePictureProgressAction |
    UpdateSecondaryPhoneNumberAction |
    UpdateZipCodeAction;